import React, { useEffect, useState, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Packages
import clsx from 'clsx';

// Actions
import { auth_token_remove } from '../../actions/authActions';
import { get_organization_info } from '../../actions/organizationActions';

// Constants
import { ROLES, ORGANIZATIONS, PRESETS } from '../../constants/permissions';

// Utils
import isEmpty from '../../utils/isEmpty';

const Navbar = () => {
	const dispatch = useDispatch();

	const { user, userInfo, isAdminUser } = useSelector(state => state.auth);

	const { global_data } = useSelector(state => state.global);

	const { organization_info } = useSelector(state => state.organization);

	const { staff } = useSelector(state => state.staff);

	const [isGeppUser, setIsGeppUser] = useState(false);

	useEffect(() => {
		dispatch(get_organization_info(user.organization));
	}, []);

	useEffect(() => {
		if (!isEmpty(organization_info)) {
			setIsGeppUser(organization_info.name === ORGANIZATIONS.GEPP);
		}
	}, [organization_info]);

	const nbaInUsername = user?.username?.toLowerCase().includes('nba');
	const hasNbaPreset = Array.isArray(staff?.presets) && staff.presets.some(p => p?.$oid === PRESETS.NBA);

	const isNbaOnly = nbaInUsername;
	const showNbaTab = nbaInUsername || hasNbaPreset || isAdminUser;

	const handleLogout = (e) => {
		e.preventDefault();
		dispatch(auth_token_remove());
	}

	return (
		<nav className='navbar navbar-expand-lg navbar-dark'>
			<div className='container-fluid'>
				<a className='navbar-brand' href='/overview'>
					<img className='d-inline-block align-items-center me-2' height={'30px'} alt='Percepthor Logo'
						src={process.env.PUBLIC_URL + '/assets/percepthor-logo.png'}
					/>
					Percepthor {organization_info?.name ? `| ${organization_info?.name}` : null}
				</a>
				<button className='navbar-toggler' type='button' data-bs-toggle='collapse' data-bs-target='#navbarNavDropdown' aria-controls='navbarNavDropdown' aria-expanded='false' aria-label='Toggle navigation'>
					<span className='navbar-toggler-icon'></span>
				</button>
				<div className='collapse navbar-collapse' id='navbarNavDropdown'>
					<ul className='navbar-nav'>
						{isNbaOnly ? (
							<li className='nav-item'>
								<a className={clsx('nav-link', { 'active': window.location.pathname.includes('/nba') })} aria-current='page' href='/nba'>
									NBA
								</a>
							</li>
						) : (
							<Fragment>
								<li className='nav-item'>
									<a className={clsx(`nav-link`, { 'active': window.location.pathname.includes('/overview') })} aria-current='page' href='/overview'>
										{global_data?.navbar?.navbrItemOverview}
									</a>
								</li>
								<li className='nav-item'>
									<a className={clsx(`nav-link`, { 'active': window.location.pathname.includes('/counters') })} aria-current='page' href='/counters'>
										{global_data?.navbar?.navbarItemStats}
									</a>
								</li>
								{user.role === ROLES.ADMIN &&
									<li className='nav-item'>
										<a className={clsx(`nav-link`, { 'active': window.location.pathname.includes('/reports') })} aria-current='page' href='/reports'>
											{global_data?.navbar?.navbarItemReports}
										</a>
									</li>
								}
								{(isAdminUser || isGeppUser) &&
									<li className='nav-item'>
										<a className={clsx(`nav-link`, { 'active': window.location.pathname.includes('/tracking') })} aria-current='page' href='/tracking'>
											Tracking
										</a>
									</li>
								}
								{showNbaTab &&
									<li className='nav-item'>
										<a className={clsx('nav-link', { 'active': window.location.pathname.includes('/nba') })} aria-current='page' href='/nba'>
											NBA
										</a>
									</li>
								}
							</Fragment>
						)}
					</ul>
					<ul className='navbar-nav ms-auto'>
						<li className='nav-item dropdown'>
							<a className='nav-link dropdown-toggle active d-flex align-items-center' href='#' id='navbarDropdown' role='button' data-bs-toggle='dropdown' aria-expanded='false'>
								<i className='bi bi-person-circle fs-5 me-2'></i>{userInfo?.username || user.username}
							</a>
							<ul className='dropdown-menu dropdown-menu-end' aria-labelledby='navbarDropdown'>
								<li>
									<a className='dropdown-item' href={process.env.REACT_APP_LOGIN + '/account'}>
										<i className='bi bi bi-person-circle me-2'></i>{global_data?.navbar?.dropDownItemAccount}
									</a>
								</li>
								<li>
									<a className='dropdown-item' href={process.env.REACT_APP_LOGIN + '/links'}>
										<i className='bi bi-grid me-2'></i>{global_data?.navbar?.dropDownItemReturn}
									</a>
								</li>
								<li><hr className='dropdown-divider'/></li>
								<li>
									<a className='dropdown-item' style={{cursor: 'pointer'}} onClick={(e) => handleLogout(e)}>
										<i className='bi bi-box-arrow-right me-2'></i>{global_data?.navbar?.dropDownItemLogOut}
									</a>
								</li>
							</ul>
						</li>
					</ul>
				</div>
			</div>
		</nav>
	);
}

export default Navbar;
